import { render, staticRenderFns } from "./view-common-tab.vue?vue&type=template&id=03d48ef3"
import script from "./view-common-tab.vue?vue&type=script&lang=js"
export * from "./view-common-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d48ef3')) {
      api.createRecord('03d48ef3', component.options)
    } else {
      api.reload('03d48ef3', component.options)
    }
    module.hot.accept("./view-common-tab.vue?vue&type=template&id=03d48ef3", function () {
      api.rerender('03d48ef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/campaign/view-common-tab.vue"
export default component.exports